import { CardMedia, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import {
  INITIAL_PAGE_PRIMARY_FONT,
  INITIAL_PAGE_SECONDARY_FONT,
} from 'src/constants/fontsConsts';
import * as Colors from 'src/theme/colors';

const useStyles = makeStyles()(() => ({
  label: {
    paddingTop: '10px',
    color: Colors.GraySmall,
  },
}));

export interface OverlayParams {
  noRowsLabel: string;
  secondaryText?: string;
  newActionButton?: React.ReactNode;
  noDataImage?: string;
  actionButton?: React.ReactNode;
  onActionButtonOptionSelected?: (option: string) => void;
  isFolderLockedForClient?: boolean;
}

interface NoDataOverlayProps {
  overlayParams: () => OverlayParams;
}

const NoDataOverlay: React.FC<NoDataOverlayProps> = ({ overlayParams }) => {
  const { noRowsLabel, secondaryText, newActionButton, noDataImage } =
    overlayParams();
  const { classes } = useStyles();
  return (
    <div className="m-auto">
      <Typography variant={INITIAL_PAGE_PRIMARY_FONT} align="center">
        {noRowsLabel}
      </Typography>
      {secondaryText && (
        <Typography
          className={classes.label}
          variant={INITIAL_PAGE_SECONDARY_FONT}
          align="center"
        >
          {secondaryText}
        </Typography>
      )}
      {newActionButton && (
        <div className="mt-2 flex justify-center">{newActionButton}</div>
      )}
      {noDataImage && <CardMedia component="img" src={noDataImage} />}
    </div>
  );
};

export default NoDataOverlay;
